<template>
  <Teleport to="body">
    <Transition name="toast" appear>
      <div
        v-if="visible"
        class="custom-toast"
        :class="[
          `toast-${type}`,
          position
        ]"
      >
        <div class="toast-content">
          <!-- <div v-if="showIcon" class="toast-icon">
            <svg v-if="type === 'success'" viewBox="0 0 24 24" fill="none">
              <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            </svg>
            <svg v-else-if="type === 'error'" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <svg v-else-if="type === 'warning'" viewBox="0 0 24 24" fill="none">
              <path d="M12 9v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M12 17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
            </svg>
            <svg v-else viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <path d="M12 16v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M12 8h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div> -->
          <div class="toast-message">{{ message }}</div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  message: {
    type: String,
    required: true
  },
  type: {
    type: String,
    default: 'info',
    validator: (value) => ['success', 'error', 'warning', 'info'].includes(value)
  },
  duration: {
    type: Number,
    default: 3000
  },
  position: {
    type: String,
    default: 'toast-center',
    validator: (value) => ['toast-top', 'toast-center', 'toast-bottom'].includes(value)
  },
  showIcon: {
    type: Boolean,
    default: true
  },
  closable: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close'])

const visible = ref(false)
let timer = null

const show = () => {
  visible.value = true
  if (props.duration > 0) {
    timer = setTimeout(() => {
      hide()
    }, props.duration)
  }
}

const hide = () => {
  visible.value = false
  emit('close')
}

const clearTimer = () => {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
}

onMounted(() => {
  show()
})

onUnmounted(() => {
  clearTimer()
})

defineExpose({
  show,
  hide
})
</script>

<style scoped lang="less">
.custom-toast {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  max-width: 80%;
  width: max-content;
  
  &.toast-top {
    top: 20px;
  }
  
  &.toast-center {
    top: 50%;
    transform: translate(-50%, -50%);
  }
  
  &.toast-bottom {
    bottom: 20px;
  }
}

.toast-content {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
}

.toast-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  
  svg {
    width: 100%;
    height: 100%;
  }
}

.toast-message {
  flex: 1;
}

// 不同类型的样式
.toast-success {
  .toast-content {
    background: rgba(0, 0, 0, 0.8);
    color: white;
    text-align: center;
  }
}

.toast-error {
  .toast-content {
    background: rgba(239, 68, 68, 0.9);
    color: white;
  }
}

.toast-warning {
  .toast-content {
    background: rgba(245, 158, 11, 0.9);
    color: white;
  }
}

.toast-info {
  .toast-content {
    // background: rgba(59, 130, 246, 0.9);
    background: rgba(0,0,0,0.8);
    color: white;
    text-align: center;
  }
}

// 动画效果
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}

// 中心位置的动画
.toast-center.toast-enter-from,
.toast-center.toast-leave-to {
  transform: translate(-50%, -50%) scale(0.8);
}

// 底部位置的动画
.toast-bottom.toast-enter-from,
.toast-bottom.toast-leave-to {
  transform: translateX(-50%) translateY(20px);
}
</style>